import GameFeature from './GameFeature.js';

export default class PseudoFeature extends GameFeature{
	constructor(eventManager, id,  name, note, description, level, maxLevel, active) {
		super(eventManager, id, name, note, description, level, maxLevel, null, null, null, null, null, null, active);
		this.featureType = "pseudoFeature";
	}
}